module.exports = __webpack_public_path__ + "img/logo_u1992-27.8dcfd2a4.svg";